<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Edit Keys</h4>
              <p>Choose default configuration and new keys</p>

              <!-- Wrapper -->
              <div v-if="Loading === true">
                <div>
                  <div class="centered">
                    <a-spin />
                  </div>
                </div>
              </div>
              <div v-else class="col-md-8 pl-0">
                <!-- Default configuration -->
                <fieldset class="border p-2 rounded">
                  <legend>Default configuration</legend>
                  <div class="row">
                    <div class="col form-group">
                      <label for="">New security role:</label>
                      <input
                        type="text"
                        class="form-control form-info-text"
                        id="newrole"
                        name="newrole"
                        :value="Role"
                        readonly="readonly"
                      />
                    </div>
                    <div class="col form-group">
                      <label for="newid">New security ID:</label>
                      <input
                        type="text"
                        class="form-control form-info-text"
                        id="newid"
                        name="newid"
                        value="unassigned"
                        readonly="readonly"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col form-group">
                      <label for="">Current keys:</label>
                      <ul
                        class="small"
                        v-for="(CurrentKey, i) in CurrentKeys"
                        :key="i"
                      >
                        <li>{{ CurrentKey.key }} - {{ CurrentKey.value }}</li>
                      </ul>
                    </div>
                    <div class="col form-group">
                      <label for="newrole">Current URLs:</label>
                      <ul
                        class="small"
                        v-for="Script in AuthorizedScripts"
                        :key="Script.script_id"
                      >
                        <li>
                          <a href="#">{{ Script.friendly_name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </fieldset>

                <!-- Security administrators rights -->
                <fieldset class="border rounded p-2 mt-2">
                  <legend>
                    Security administrators rights
                  </legend>
                  <div class="form-group">
                    <label for="">Allow user to add new users?</label>
                    <div class="row">
                      <div class="col-md-2">
                        <label
                          ><input
                            type="radio"
                            name="newuser"
                            v-model="NewUsers"
                            :value="false"
                          />
                          No</label
                        >
                      </div>
                      <div class="col-md-2">
                        <label
                          ><input
                            type="radio"
                            name="newuser"
                            v-model="NewUsers"
                            :value="true"
                          />
                          Yes</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">Allow user to add new security roles?</label>

                    <div class="row">
                      <div class="col-md-2">
                        <label
                          ><input
                            type="radio"
                            name="newroles"
                            v-model="NewRole"
                            :value="false"
                          />
                          No</label
                        >
                      </div>
                      <div class="col-md-2">
                        <label
                          ><input
                            type="radio"
                            name="newroles"
                            v-model="NewRole"
                            :value="true"
                          />
                          Yes</label
                        >
                      </div>
                    </div>
                  </div>
                </fieldset>

                <!-- Add or edit key value pairs -->
                <fieldset class="border rounded p-2 mt-2">
                  <legend>
                    Add or edit key value pairs - Adding {{ MaxKeys }} new keys
                    to "{{ Role }}"
                  </legend>

                  <div class="row" v-for="(Key, i) in Keys" :key="i">
                    <div class="col form-group">
                      <label>Key Name:</label>
                      <input
                        type="text"
                        size="10"
                        name="keyname"
                        v-model="Key.key"
                        class="form-control"
                      />
                    </div>
                    <div class="col form-group">
                      <label>Key Value:</label>
                      <input
                        type="text"
                        size="10"
                        name="keyvalue"
                        v-model="Key.value"
                        class="form-control"
                      />
                    </div>
                  </div>
                </fieldset>

                <!-- Authorize "RoleName" for the following applications -->
                <fieldset
                  v-show="UnauthorizedScripts.length > 0"
                  class="border rounded p-2 mt-2"
                >
                  <legend>
                    Authorize "{{ Role }}" for the following applications
                  </legend>
                  <p>Choose scripts to authorize</p>
                  <div style="display: grid; grid-template-columns: 1fr 1fr;">
                    <div
                      v-for="Script in UnauthorizedScripts"
                      :key="Script.script_id"
                      class="pb-2 "
                    >
                      <input
                        type="checkbox"
                        v-model="UpdatedAuthorizedScripts"
                        :id="Script.script_id"
                        :value="+Script.script_id"
                      />
                      {{ Script.friendly_name }}
                    </div>
                  </div>
                </fieldset>

                <div class="button-tray mt-2 mb-3">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="saveNewSecurityRole"
                  >
                    Save
                  </button>
                  <router-link
                    style="color: white;"
                    class="ml-2 btn btn-danger"
                    :to="{ name: 'DivvyAdminManageSecurityRoles' }"
                  >
                    Cancel
                  </router-link>
                </div>
              </div>

              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "EditKeysPage",
  data() {
    return {
      Role: this.$route.params.role,
      MaxKeys: this.$route.params.keys,
      Clone: this.$route.params.clone,
      NewRole: false,
      NewUsers: false,
      CurrentKeys: [],
      Keys: [],
      AuthorizedScripts: [],
      UnauthorizedScripts: [],
      UpdatedAuthorizedScripts: [],
      Loading: false,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageRoles",
        activeMenu: this.activeMenu ? this.activeMenu : "security",
      });
    },
    formKeys() {
      const maxKeys = this.MaxKeys;
      let Keys = [];
      for (let i = 1; i <= maxKeys; i++) {
        Keys.push({
          key: "",
          value: "",
        });
      }
      // console.log(Keys);
      this.Keys = Keys;
    },
    saveNewSecurityRole() {
      try {
        const payload = {
          label: this.Role,
          sec_context: {
            version: "1.0",
            header: "",
            data: {
              struct: {
                var: [
                  {
                    key: "LABEL",
                    value: this.Role,
                  },
                  {
                    key: "NEWCONTEXT",
                    value: this.NewRole === false ? "no" : "yes",
                  },
                  {
                    key: "NEWUSERS",
                    value: this.NewUsers === false ? "no" : "yes",
                  },
                  {
                    key: "SECID",
                    value: "",
                  },
                  {
                    key: "URLS",
                    value: this.UpdatedAuthorizedScripts.join(","),
                  },
                  ...this.CurrentKeys,
                  ...this.Keys,
                ],
              },
            },
          },
          user_ids: {
            version: "1.0",
            header: "",
            data: {
              recordset: {
                row_count: "0",
                field_names: "id,added",
                type: "coldfusion.sql.QueryTable",
                fields: [
                  {
                    key: "id",
                    value: "",
                  },
                  {
                    key: "added",
                    value: "",
                  },
                ],
              },
            },
          },
        };
        console.log(payload);
        this.$store
          .dispatch("manageRoles/addSecurityRole", payload)
          .then(() => {
            this.$router.push({ name: "DivvyAdminManageSecurityRoles" });
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.Loading = true;
    this.setActiveMenuItem();
    this.formKeys();
    // to check for no cloning case
    if (this.Clone !== 0) {
      this.$store
        .dispatch("manageRoles/fetchSecurityRolesById", {
          secid: this.Clone,
        })
        .then((data) => {
          this.Loading = false;
          // for getting URLs and unauthorized scripts
          let AuthorizedScripts = [];
          let UnauthorizedScripts = [];

          data.authorized_scripts?.forEach((authorized_script) => {
            AuthorizedScripts.push(authorized_script.scripts);
          });
          AuthorizedScripts.forEach((authScript) => {
            this.AuthorizedScripts = [...this.AuthorizedScripts, ...authScript];
          });

          data.unauthorized_scripts?.forEach((unauthorized_script) => {
            UnauthorizedScripts.push(unauthorized_script.scripts);
          });
          UnauthorizedScripts.forEach((unauthScript) => {
            this.UnauthorizedScripts = [
              ...this.UnauthorizedScripts,
              ...unauthScript,
            ];
          });

          // key/value pairs
          const KeyValuePairs = data.sec_context.data.struct.var.filter(
            (keyval) =>
              keyval.key !== "URLS" &&
              keyval.key !== "LABEL" &&
              keyval.key !== "NEWCONTEXT" &&
              keyval.key !== "NEWUSERS" &&
              keyval.key !== "SECID" &&
              keyval.value !== ""
          );
          this.CurrentKeys = KeyValuePairs;

          // for getting selected scripts
          const UpdatedAuthorizedScripts = data.sec_context.data.struct.var.filter(
            (keyval) => keyval.key === "URLS"
          );
          this.UpdatedAuthorizedScripts = UpdatedAuthorizedScripts[0].value.split(
            ","
          );
          this.UpdatedAuthorizedScripts = this.UpdatedAuthorizedScripts.map(
            (num) => +num
          );
        });
    } else {
      this.$store.dispatch("manageRoles/fetchScripts").then((data) => {
        this.Loading = false;
        try {
          let UnauthorizedScripts = [];
          data?.forEach(({ friendly_name, script_id }) => {
            UnauthorizedScripts.push({ friendly_name, script_id });
          });
          this.UnauthorizedScripts = UnauthorizedScripts;
        } catch (error) {
          console.log(error);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
